import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const Baseurl = process.env.REACT_APP_API_URL;

export const post_Delivery_partner = createAsyncThunk(
    "partner/post_Delivery_partner",
    async (formData, thunkAPI) => {
        try {
            const config = {
                headers: { "Content-Type": "application/json" },
            };
            const url = `${Baseurl}/api/v1/deliverypartner/new`;
            const resp = await axios.post(url, formData, config);
            return resp.data;
        } catch (error) {
            return thunkAPI.rejectWithValue("partner Not create");
        }
    }
);


export const validateEmail = createAsyncThunk(
    "partner/validateEmail",
    async (data, thunkAPI) => {
        try {
            const url = `${Baseurl}/api/v1/deliverypartner/verify-email/${data}`;
            const resp = await axios.get(url);
            return resp.data;
        } catch (error) {
            return error;
        }
    }
);

export const validateMobile = createAsyncThunk(
    "partner/validateMobile",
    async (data, thunkAPI) => {
        try {
            const url = `${Baseurl}/api/v1/deliverypartner/verify-mobile/${data}`;
            const resp = await axios.get(url);
            return resp.data;
        } catch (error) {
            return error;
        }
    }
);

export const validateValiId = createAsyncThunk(
    "partner/validateValiId",
    async (data, thunkAPI) => {
        try {
            const url = `${Baseurl}/api/v1/deliverypartner/verify-valid-id/${data}`;
            const resp = await axios.get(url);
            return resp.data;
        } catch (error) {
            return error;
        }
    }
);


const initialState = {
    delivery_partner: JSON.parse(localStorage.getItem("delivery_partner"))
        ? JSON.parse(localStorage.getItem("delivery_partner")).sort((a, b) =>
            a.createdAt > b.createdAt ? 1 : -1
        )
        : [],
    delivery_partnerLoading: true,
    isdelivery_partnerAvailable: localStorage.getItem("delivery_partner") ? true : false,
};


const PartnerSlice = createSlice({
    name: "partner",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(post_Delivery_partner.pending, (state) => {
                state.delivery_partnerLoading = true;
            })
            .addCase(post_Delivery_partner.fulfilled, (state, action) => {
                state.delivery_partner = [...state.delivery_partner, action.payload.deliveryPersion];
                state.delivery_partner = state.delivery_partner.sort((a, b) =>
                    a.createdAt > b.createdAt ? 1 : -1
                );

                localStorage.setItem(
                    "delivery_partner",
                    JSON.stringify(state.delivery_partner)
                );
                state.delivery_partnerLoading = false;
                state.isdelivery_partnerAvailable = true;
            })
            .addCase(post_Delivery_partner.rejected, (state) => {
                state.delivery_partnerLoading = true;
            });
    }
});

export const { } = PartnerSlice.actions;
export default PartnerSlice.reducer;